/**
 * Global animate-on-scroll utility
 * Initializes IntersectionObserver for elements with .sequence-animate-on-scroll class
 */

(function () {
  // Generic animate-on-scroll utility for hero images and other elements
  const initGlobalAnimateOnScroll = () => {
    const elements = document.querySelectorAll('.sequence-animate-on-scroll');
    if (!elements.length) {
      return;
    }

    if (!window.sequenceAnimateOnScrollObserver) {
      const globalObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              globalObserver.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.3,
          rootMargin: '0px 0px -10% 0px',
        }
      );

      window.sequenceAnimateOnScrollObserver = globalObserver;
    }

    elements.forEach((el) => {
      if (!el.classList.contains('is-visible')) {
        window.sequenceAnimateOnScrollObserver.observe(el);
      }
    });
  };

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGlobalAnimateOnScroll);
  } else {
    initGlobalAnimateOnScroll();
  }

  // Re-initialize for dynamically added content (e.g., section rendering)
  document.addEventListener('shopify:section:load', initGlobalAnimateOnScroll);
})();

